import { createComponent } from '@carvana/merch-components';
import NewPriceIcon from '~/icons/NewPriceIcon';
import Wave from '~/icons/Wave';

type ExtendedNewPriceIconProps = React.SVGProps<SVGSVGElement> & {
  isInRestrictedState?: boolean;
};

export const SectionWrapper = createComponent('div', {
  className:
    'relative z-[0] w-full max-w-[1055px] overflow-hidden rounded-md border border-green-2 bg-white'
});

export const InnerWrapper = createComponent('div', {
  className: 'flex flex-col items-center p-24 m:flex-row m:gap-40 m:py-20'
});

export const ImageWrapper = createComponent('div', {
  className: 'relative flex h-[140px] items-center m:h-[170px] l:h-[210px]'
});

export const VehicleImage = createComponent('img', {
  className:
    'h-full w-[279px] rounded-t-md object-cover m:min-w-[350px] l:min-w-[419px]'
});

export const ContentWrapper = createComponent('div', {
  className:
    'flex max-w-[430px] flex-col items-center gap-16 m:max-w-full m:items-start m:gap-24'
});

export const StyledWave = createComponent(Wave, {
  className:
    'absolute inset-1/2 -z-10 min-h-full min-w-full -translate-x-1/2 -translate-y-[12%] m:-translate-y-[50%]'
});

export const ContentText = createComponent('span', {
  className: 'text-center text-blue-6 tl-header-m m:text-left l:tl-header-xl'
});

export const StyledNewPriceIcon = createComponent<ExtendedNewPriceIconProps>(
  NewPriceIcon,
  {
    className:
      'absolute -right-[3px] top-[1px] h-[42px] h-[50px] w-[42px] w-[50px] m:-right-[6px] m:-top-[9px] m:z-[1] m:h-[74px] m:w-[74px] l:-right-[3px] l:top-[3px]'
  }
);
